module.exports = __webpack_public_path__ + "static/media/day18_stars.eaeb9d12.gif";